export default __webpack_public_path__ + "static/beach-8fd064e3fd353535654aec1da0f162dd.webp";